import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { useWindowSize } from '@/hooks/useWindowSize';
import { prettyDate, prettyFloatMoney } from '@/helpers/utils';
import { useGetCashMovementsList } from '@/query/queries/report/useGetCashMovementsList';
import { Checkbox } from '@/webkit/form/Checkbox';
import { FilterViewDesktop } from './desktop';
import { FilterViewMobile } from './mobile';
import s from './index.module.scss';

export const Filters = props => {
  const { params, setParams } = props;
  const { isMobile } = useWindowSize();
  const { t } = useTranslation('reports');

  const { data } = useGetCashMovementsList({
    page: params.page,
    date_from: params.range[0],
    date_to: params.range[1],
    operation_types: params.operation_types,
    grouping: JSON.stringify(params.grouping),
  });

  const onFilterChange = (key, value) => {
    setParams(prev => ({ ...prev, page: 1, [key]: value }));
  };

  return (
    <div className={s.wrapper}>
      {isMobile ? (
        <FilterViewMobile {...props} onFilterChange={onFilterChange} />
      ) : (
        <FilterViewDesktop {...props} onFilterChange={onFilterChange} />
      )}
      <div className={s.footer}>
        <div className={s.left}>
          <div className="f-small-regular">
            {t('cash_filters.cash_movements', {
              from: prettyDate(params.range[0], 'DD MMMM YYYY'),
              to: prettyDate(params.range[1], 'DD MMMM YYYY'),
            })}
          </div>
          {data && (
            <div className="f-small-regular" style={{ color: '#52626F' }}>
              {t('cash_filters.opening_balance', {
                date: prettyDate(params.range[0], 'DD MMMM YYYY'),
                amount: prettyFloatMoney(data.opening_balance),
              })}
            </div>
          )}
        </div>
        <Checkbox
          name="grouping"
          checked={params.grouping}
          onChange={() =>
            setParams(prev => ({
              ...prev,
              page: 1,
              grouping: !params.grouping,
            }))
          }
        >
          <span className={classnames(s.grouping, 'f-small-regular')}>
            {t('cash_filters.group_by_operation')}
          </span>
        </Checkbox>
      </div>
    </div>
  );
};
